var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWostk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13104 -1736)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-13104 1736)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13099 1742.577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1727.928-449.194q-5.7,0-11.391,0a1.5,1.5,0,0,1-1.667-1.659q0-9.8,0-19.591a1.473,1.473,0,0,1,1.183-1.56,1.571,1.571,0,0,1,1.925.963,2.188,2.188,0,0,1,.076.672q.006,8.679,0,17.359c0,.651,0,.653.651.653h20.685a1.464,1.464,0,0,1,1.559,1.061,1.52,1.52,0,0,1-.6,1.837,2.15,2.15,0,0,1-1.031.254C1735.521-449.188,1731.724-449.194,1727.928-449.194Z",
    transform: "translate(-1714.869 472.039)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1949.208-447.175q0-3.232,0-6.463c0-.64.131-.811.779-.86a11.493,11.493,0,0,1,1.59-.01c.594.038.793.282.793.884q0,6.463,0,12.927c0,.626-.182.823-.8.844-.546.019-1.093.02-1.638,0s-.723-.229-.723-.769Q1949.207-443.9,1949.208-447.175Z",
    transform: "translate(-1927.853 456.126)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1897.978-451.2c0,.775.006,1.549,0,2.324-.007.754-.239.979-.981.979-.471,0-.942.009-1.412,0a.725.725,0,0,1-.808-.786c-.012-1.64-.008-3.28,0-4.921a.681.681,0,0,1,.669-.771,15.765,15.765,0,0,1,1.863,0c.47.031.664.3.671.813C1897.985-452.776,1897.978-451.986,1897.978-451.2Z",
    transform: "translate(-1878.373 456.011)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1841.031-414.937c0-.8,0-1.606,0-2.409a.668.668,0,0,1,.745-.762q.84-.015,1.682,0a.679.679,0,0,1,.747.767q.006,2.454,0,4.909a.678.678,0,0,1-.751.762q-.841.016-1.682,0a.668.668,0,0,1-.74-.767C1841.027-413.27,1841.031-414.1,1841.031-414.937Z",
    transform: "translate(-1829.533 423.03)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.065-361.008c0,.789.006,1.579,0,2.368-.006.624-.223.853-.843.87-.547.016-1.093.016-1.639-.005a.641.641,0,0,1-.713-.71q-.023-2.482,0-4.964c.005-.523.255-.749.766-.762.531-.013,1.063-.012,1.594,0,.593.012.827.244.834.836C1790.073-362.587,1790.065-361.8,1790.065-361.008Z",
    transform: "translate(-1780.297 374.046)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWostk);
export default __webpack_public_path__ + "static/media/wostk.c3b5ed0c.svg";
export { ForwardRef as ReactComponent };